import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule, FeaturesConfigModule, UrlModule, ConfigModule, CmsConfig } from '@spartacus/core';
import {
  AtMessageModule,
  IconModule,
  ItemCounterModule,
  ListNavigationModule,
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageComponentModule,
  PageLayoutModule,
  SpinnerModule,
  StarRatingModule,
} from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AirdiskFleetSafetyComponent } from './airdisk-fleet-safety/airdisk-fleet-safety.component';
import { AirdiskFrictionMaintainanceComponent } from './airdisk-friction-maintainance/airdisk-friction-maintainance.component';
import { AirdiskDrumBreakCostsComponent } from './airdisk-drum-break-costs/airdisk-drum-break-costs.component';
import { AirdiskCsaViolationCostsComponent } from './airdisk-csa-violation-costs/airdisk-csa-violation-costs.component';
import { AirdiskRustMaintainanceComponent } from './airdisk-rust-maintainance/airdisk-rust-maintainance.component';
import { AirdiskDrumSummaryComponent } from './airdisk-drum-summary/airdisk-drum-summary.component';
import { AirdiskEmailComponent } from './airdisk-email/airdisk-email.component';
import { AirdiskFleetInfoComponent } from './airdisk-fleet-info/airdisk-fleet-info.component';
import { AirdiskLeftComponent } from './airdisk-left/airdisk-left.component';
import { AirdiskMainComponent } from './airdisk-main/airdisk-main.component';
import { AirdiskTooltipPopUpComponent } from './airdisk-tooltip-pop-up/airdisk-tooltip-pop-up.component';
import { AirdiskVistorInfoComponent } from './airdisk-vistor-info/airdisk-vistor-info.component';
import { AirdiskCostSummaryComponent } from './airdisk-cost-summary/airdisk-cost-summary.component';
import { AirdiskValueDisclaimerComponent } from './airdisk-value-disclaimer/airdisk-value-disclaimer.component';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbDirectivesModule } from '../../directives/kb-directives.module';
import { EnvironmentService } from 'src/app/services/environment.service';

@NgModule({
  declarations: [
    AirdiskVistorInfoComponent,
    AirdiskFleetInfoComponent,
    AirdiskFleetSafetyComponent,
    AirdiskFrictionMaintainanceComponent,
    AirdiskDrumBreakCostsComponent,
    AirdiskCsaViolationCostsComponent,
    AirdiskRustMaintainanceComponent,
    AirdiskCostSummaryComponent,
    AirdiskDrumSummaryComponent,
    AirdiskEmailComponent,
    AirdiskLeftComponent,
    AirdiskMainComponent,
    AirdiskTooltipPopUpComponent,
    AirdiskValueDisclaimerComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    AtMessageModule,
    FeaturesConfigModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    OutletRefModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    TooltipModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    PageLayoutModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    KbDirectivesModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AirDiscBreakValueCalculatorFlexComponent: {
          component: AirdiskMainComponent,
          guards: [SecureGuard],
        },
      },
    } as CmsConfig),
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useFactory: (config: EnvironmentService): RecaptchaSettings => {
        return { siteKey: config.getConfig().googleReCaptchaKey };
      },
      deps: [EnvironmentService],
    },
  ],
})
export class AirdiskBrakeModule {}
